import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { Button, Card, CardContent, CardHeader } from '@material-ui/core';
import useStyles from './dashboardstyles'
import DashboardTable from './dashboardtable'
import './dashboardstyles.css'
import { CommonConfig } from '../../../config/common-config';
import { userType } from '../../../config/usertypeValue';
import TabList from '../../../components/checklistTab/tabList';
import buttonDisable from '../../../components/disableField/buttonDisable';
import SuccessPopUp from '../../../components/loaderpopup/success';
import LoaderPopUp from '../../../components/loaderpopup/loader';
import { setSelectedStageId } from '../../services/store/actions';

const DetailAnalysis = () => {
    const classes = useStyles();
    const history = useHistory();
    const dispatch = useDispatch({});
    const imcNameSelected = useSelector((state) => state.serviceCheckListReducer.imcNameSelected);
    // const tennantDetails = useSelector((state) => state.loginsuccessreducer.tennantName.tennantName);
    const serviceIdSelected = useSelector((state) => state.serviceCheckListReducer.serviceIdSelected);
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const stageId = useSelector((state) => state.serviceCheckListReducer.selectedStageId);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const [savedJson, setSavedJson] = useState([]);
    const [AnalaysisRows, setAnalysisRows] = React.useState([]);
    const [AssigedUsers, setassigedUsers] = React.useState([]);
    const [reRender, setreRender] = React.useState();
    const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    const usertype = userDetails.result && userDetails.result.data.features[5].branchName;
    const [isDisable, setIsDisable] = useState(true);
    const [showLoader, setShowLoader] = useState(false);
    const [successpop, setSuccessPop] = useState(false);
    const [savepop, setSavePop] = useState(false);
    const [reworkpop, setReworkpop] = useState(false);


    const headCells = [
        { id: 'questionText', label: 'What to analyze' },
        // { id: 'remarkByCoreteam', label: 'Remarks by team' },
        // { id: 'remarkByItecteam', label: 'Remarks by Itec team' } 
    ];

    const addRemarks = (questionId, remark) => {

        const newArray = AnalaysisRows.map(row => {
            if (row.questionId === questionId) {
                row.remarkByCoreteam.unshift(remark);
            }
            return row;
        })
        setAnalysisRows(newArray)

    }

    const getResults = () => {
        const axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                Authorization: bearerToken,
            },
        };
        axios
            .get(`${CommonConfig.dev.baseUrl1}/api/itr/detailed-analysis/by-serviceId/${imcNameSelected}/${serviceIdSelected}`, axiosConfig)
            .then((response) => {
                const data =
                    response.data &&
                    response.data.detailedAnalysis &&
                    response.data.detailedAnalysis.map((rowData) => {
                        return rowData;
                    });
                const dataAssignedUser =
                    response.data &&
                    response.data.assigedUsers &&
                    response.data.assigedUsers.map((rowData) => {
                        return rowData;
                    });
                setAnalysisRows(data);
                setassigedUsers(dataAssignedUser)
            })
            .catch((error) => {
            });
    };

    useEffect(() => {
        userType.value = 'Detailed Analysis';
        getResults();
    }, [imcNameSelected, serviceIdSelected, reRender]);


    const savenSubmitData = (actionType) => {
        setSavedJson((prev) => ({ ...prev, detailedAnalysis: [...AnalaysisRows], assigedUsers: [...AssigedUsers], additionalQuestion: [] }));

        setSavedJson((updatedJson) => {
            setShowLoader(true);
            const axiosConfig = {
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    Authorization: bearerToken,
                },
            };
            const assignedData = JSON.stringify({
                serviceId: serviceIdSelected,
                detailedAnalysisJson: {
                    ...updatedJson
                },
                remarks: 'Remarks',
            });

            axios
                .put(
                    `${CommonConfig.dev.baseUrl1}/api/itr/detailed-analysis/em-${actionType}/${imcNameSelected}`,
                    JSON.parse(assignedData),
                    axiosConfig
                )
                .then((response) => {
                    if (response.status === 200) {
                        if (actionType == 'save') {
                            setreRender('update');
                            setIsDisable(false);
                            setTimeout(() => {
                                setShowLoader(false);
                                setSavePop(true);
                            }, 1500);
                            setTimeout(() => {
                                handleClose();
                                setSavePop(false);
                            }, 3000);
                        }
                        if (actionType == 'submit') {
                            setTimeout(() => {
                                setShowLoader(false);
                                setSuccessPop(true);
                            }, 1500);
                            setTimeout(() => {
                                setSuccessPop(false);
                                handleClose();
                                // history.push('/menu/openservice');
                                // userType.value === "Draft Statements"
                                dispatch(setSelectedStageId(16));
                                history.push({
                                    pathname: '/menu/imc-draft-document',
                                    state: { path: "openservices" },
                                });
                            }, 3000);
                        }
                        if (actionType == 'rework') {
                            setTimeout(() => {
                                setShowLoader(false);
                                setReworkpop(true);
                            }, 1500);
                            setTimeout(() => {
                                setReworkpop(false);
                                handleClose();
                                history.push('/menu/openservice');
                            }, 3000);
                        }
                    }
                })
                .catch(() => {
                });
        });
    }

    const handleClose = () => {
        setShowLoader(false);
    }

    const navigateBack = () => {
        history.push({
            pathname: '/menu/openservice',
        });
    }

    return (
        <div className={classes.root}>

            {successpop ? (<SuccessPopUp open={successpop} showSuccess={successpop} handleClose={handleClose} title="Submitted Detailed Analysis successfully" />) : null}
            {savepop ? (<SuccessPopUp open={savepop} showSuccess={savepop} handleClose={handleClose} title="Details saved successfully" />) : null}
            {reworkpop ? (<SuccessPopUp open={reworkpop} showSuccess={reworkpop} handleClose={handleClose} title="Requested for Rework" />) : null}
            {(showLoader ? (<LoaderPopUp showLoader={showLoader} handleClose={handleClose} title="Please wait while we saving/submitting your data" />) : null)}

            {/* <div className="stage-indicator">
                <ul>
                    <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L1 Checklist')}>L1 Checklist</li>
                    <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 CRC Confirmed')}>L1 CRC Confirmed</li>
                    <li className="active">Detailed Analysis</li>
                </ul>
            </div> */}
            <TabList />
            <Card className="common-card">
                <CardHeader title={'Detailed Analysis'} />
                <CardContent>
                    <DashboardTable
                        headCells={headCells}
                        AnalaysisRows={AnalaysisRows}
                        pageName="dashboard"
                        action="document"
                        addRemarks={addRemarks}
                    />
                </CardContent>
            </Card>
            <div className="detailed-actions">
                <ul>
                    <li>
                        <Button type="button" color="primary" variant="contained" size="large" onClick={() => navigateBack()} disabled={usertype === "EM" ? buttonDisable(stageId, userType.value) : usertype === "Other employee users"}>  Back </Button>
                    </li>
                    <li>
                        <Button type="button" color="primary" variant="contained" size="large" disabled={usertype === "EM" ? buttonDisable(stageId, userType.value) : usertype === "Other employee users"} onClick={() => savenSubmitData('save')} >  Save </Button>
                    </li>
                    <li>
                        <Button type="button" color="primary" variant="contained" size="large" disabled={usertype === "EM" ? isDisable || buttonDisable(stageId, userType.value) : usertype === "Other employee users"} onClick={() => savenSubmitData('rework')} > Send for Rework on DA</Button>
                    </li>
                    <li>
                        <Button type="submit" color="primary" variant="contained" size="large" disabled={usertype === "EM" ? isDisable || buttonDisable(stageId, userType.value) : usertype === "Other employee users"} onClick={() => savenSubmitData('submit')} > Submit </Button>
                    </li>
                </ul>
            </div>
        </div>
    )
}

export default DetailAnalysis;
